import { combineReducers } from 'redux'

import exercicios from './exercicios'
import exerciciosReceitaArrecadada from './exerciciosReceitaArrecadada'
import exerciciosOperacoesDespesas from './exerciciosOperacoesDespesas'
import orgao from './orgao'
import recursosVinculados from './recursosVinculados'
import recursosDestinacao from './recursosDestinacao'
import tipoRecursosVinculados from './tipoRecursosVinculados'
import referencia from './referencia'
import orgaoSecretariaServidor from './orgaoSecretariaServidor'
import cargo from './cargo'
import vinculo from './vinculo'
import setor from './setor'
import tipoConvenio from './tipoConvenio'
import exercicioMetasEducacao from './exercicioMetasEducacao'
import descricaoMeta from './descricaoMeta'
import situacaoCronologica from './situacaoCronologica'
import grupos from './grupos'
import exercicioDetalhamentoDespesas from './exercicioDetalhamentoDespesas'
import exercicioCreditoOrcamentarioReceitasProprias from './exercicioCreditoOrcamentarioReceitasProprias'
import recursosPorExercicio from './recursosPorExercicio'
import baseLegal from './baseLegal'
import fonte from './fonte'
import funcao from './funcao'
import subFuncao from './subFuncao'
import despesa from './despesa'
import exercicioLoteServico from './exercicioLoteServico'
import tipoServico from './tipoServico'
import recursosVinculadosPorExercicio from './recursosVinculadosPorExercicio'

export default combineReducers({
    exercicios,
    exerciciosReceitaArrecadada,
    exerciciosOperacoesDespesas,
    orgao,
    recursosVinculados,
    recursosDestinacao,
    tipoRecursosVinculados,
    referencia,
    orgaoSecretariaServidor,
    cargo,
    vinculo,
    setor,
    tipoConvenio,
    exercicioMetasEducacao,
    descricaoMeta,
    situacaoCronologica,
    grupos,
    exercicioDetalhamentoDespesas,
    exercicioCreditoOrcamentarioReceitasProprias,
    recursosPorExercicio,
    baseLegal,
    fonte,
    funcao,
    subFuncao,
    despesa,
    exercicioLoteServico,
    tipoServico,
    recursosVinculadosPorExercicio,
})
